import { Component, Inject } from '@angular/core';

@Component({
    selector: 'app-busy-spinner',
    templateUrl: './busy-spinner.component.html',
    styleUrls: ['./busy-spinner.component.css']
})
export class BusySpinnerComponent {

    constructor() {

        //
    }
}



// WEBPACK FOOTER //
// ./src/app/busy-spinner/busy-spinner.component.ts